import React from 'react';
import Localization from '../../Localization';

import './styles.scss';

export default function FAQ(props) {
  const { setShow, showAbout } = props;
  const FAQContent = Localization.get('faqText');

  return (
    <div>
      <h1>{Localization.get('FAQ')}</h1>
      <div className='close' onClick={() => setShow(false)}>x</div>
      <div className='FAQ content'>
        <FAQContent showAbout={showAbout} />
      </div>
      <div className='button' onClick={() => setShow(false)}>
        <button>
          {Localization.get('Close')}
        </button>
      </div>
    </div>
  );
}